<template>
  <div class="popup" v-body-scroll-lock="show" v-if="show" @click="show = !show">
    <div class="popup-close">
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
           viewBox="0 0 22.88 22.88">
        <path style="fill:#1E201D;" d="M0.324,1.909c-0.429-0.429-0.429-1.143,0-1.587c0.444-0.429,1.143-0.429,1.587,0l9.523,9.539
	l9.539-9.539c0.429-0.429,1.143-0.429,1.571,0c0.444,0.444,0.444,1.159,0,1.587l-9.523,9.524l9.523,9.539
	c0.444,0.429,0.444,1.143,0,1.587c-0.429,0.429-1.143,0.429-1.571,0l-9.539-9.539l-9.523,9.539c-0.444,0.429-1.143,0.429-1.587,0
	c-0.429-0.444-0.429-1.159,0-1.587l9.523-9.539L0.324,1.909z"/>
      </svg>
    </div>
    <div class="popup-box" @click.stop>
      <youtube
          :video-id="videoId"
          ref="youtube"
          :player-vars="{autoplay: true}"
          @ended="videoEnded"
      ></youtube>
    </div>
  </div>
</template>

<script>
import {bus} from "../../../utils/bus";

export default {
  name: "CustomYouTube",
  props: ['poster', 'video'],
  data() {
    return {
      videoId: 'lG0Ys-2d4MA',
      show: false
    }
  },
  methods: {
    openPlayer() {
      this.show = !this.show;
      this.$refs.youtube.player.playVideo()
    },
    playVideo() {
      this.$refs.youtube.player.playVideo()
    },
    videoEnded() {
      this.show = false;
    }
  },
  computed: {
    player() {
      return this.$refs.youtube.player
    },
  },
  mounted() {
    bus.$on('open-video', (i) => {
      this.videoId = i
      this.show = true
    })
  }
}
</script>

<style lang="scss">
@import "youtube";
</style>
